import { Actions, UseSoundOutWordsState } from './types';

const selectedWordInitialState = { text: [], index: -1 };

export const spelledCharacterInitialState = { character: '', index: -1 };

const currentPageInitialState = {
  orderedWords: [],
  selectedWord: selectedWordInitialState,
  activityStarted: false,
  spelledCharacter: spelledCharacterInitialState,
};

export const initialState = {
  ...currentPageInitialState,
  pages: {},
};

export const reducers = (state: UseSoundOutWordsState, action: Actions): UseSoundOutWordsState => {
  switch (action.type) {
    case 'SET_ORDERED_WORDS':
      return { ...state, ...currentPageInitialState, orderedWords: action.payload.orderedWords };
    case 'SET_SELECTED_WORD':
      return {
        ...state,
        activityStarted: action.payload.selectedWord.index >= 0,
        selectedWord: action.payload.selectedWord,
      };
    case 'SET_VISITED_WORDS':
      return {
        ...state,
        pages: {
          ...state.pages,
          [action.payload.page]: {
            ...state.pages[action.payload.page],
            visitedWords: [
              ...new Set([
                ...(state.pages[action.payload.page]?.visitedWords ?? []),
                action.payload.index,
              ]),
            ],
          },
        },
      };
    case 'SET_SPELLED_CHARACTER':
      return { ...state, spelledCharacter: action.payload.spelledCharacter };
  }
};
